<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Contacto</th>
                <th :class="StyleTh">Clientes</th>
                <th :class="StyleTh">Fecha del Evento</th>
                <th :class="StyleTh">Estatus Solicitud</th>
                    
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
    
            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                        <td><p :class="StyleTd">{{lista.NombreCompleto}}</p></td>
                        <td><p :class="StyleTd">{{lista.Nombres}}</p></td>
                        <td><p :class="StyleTd">{{lista.FechaEvento}}</p></td>
                        <td><p :class="StyleTd">{{ lista.EstatusSolicitud }}</p>
                        </td>
                        
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="false" :pId="lista.IdSolicitudSalida" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                            <template slot="btnaccion">
                                <button @click="IrASolicitud(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1">
                                    <i class="far fa-clipboard text-primary"></i> 
                                    {{ lista.EstatusSolicitud=='No Elaborada' ? 'Realizar Solicitud' : 'Ver Solicitud' }}
                                </button>

                                <template v-if="lista.EstatusSolicitud!='No Elaborada'">
                                <CMoreButtonsL>
                                    <template slot="bodyBtnsL">
    
                                        <li v-if="lista.EstatusSolicitud=='Autorizada' && lista.IdSolicitudSalidaExtra==''" @click="IrASolicitudExtraoficial(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-clipboard"></i> Realizar Solicitud Extra Oficial
                                            </a>
                                        </li>
    
                                        <li v-if="lista.EstatusSolicitud!='No Elaborada'" @click="VerPdf()">
                                            <a class="dropdown-item">
                                                <i class="far fa-file-pdf"></i> Ver PDF
                                            </a>
                                        </li>
    
                                        <li v-if="lista.EstatusSolicitud=='Elaborado' && lista.IdSolicitudSalidaExtra==''" @click="VerificarSalida(lista,'normal')">
                                            <a class="dropdown-item">
                                                <i class="far fa-clipboard-check"></i> Confirmar Salidas
                                            </a>
                                        </li>

                                        <li v-if="lista.EstatusSalidaExtra=='Elaborado' && lista.IdSolicitudSalidaExtra!=''" @click="VerificarSalida(lista,'extra')">
                                            <a class="dropdown-item">
                                                <i class="far fa-clipboard-check"></i> Confirmar Salidas Extra
                                            </a>
                                        </li>

                                        <li v-if="lista.EstatusSolicitud=='Autorizada'" @click="RealizarEntradas(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-clipboard-check"></i> Realizar Entradas
                                            </a>
                                        </li>
                                    </template>
                                </CMoreButtonsL>
                                </template>
                            </template>
                        </CBtnAccion>     
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros>
            </template>
        </CList>

        <CModal :pConfigModal="ConfigModalAutorizarSalida" :poBtnSave="oBtnSaveAutorizarSalida">
			<template slot="Form">
				<FormAutorizarSalida :poBtnSave="oBtnSaveAutorizarSalida"></FormAutorizarSalida>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModalAutorizarSalidaExtra" :poBtnSave="oBtnSaveAutorizarSalidaExtra">
			<template slot="Form">
				<FormAutorizarSalidaExtra :poBtnSave="oBtnSaveAutorizarSalidaExtra"></FormAutorizarSalidaExtra>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModalEntrada" :poBtnSave="oBtnSaveEntrada">
			<template slot="Form">
				<FormEntrada :poBtnSave="oBtnSaveEntrada"></FormEntrada>
			</template>
		</CModal>
    </div>

</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
import FormAutorizarSalida from './modales/AutorizarSalidaForm.vue';
import FormAutorizarSalidaExtra from './modales/AutorizarSalidaExtraForm.vue';
import FormEntrada from './modales/EntradaForm.vue';
const EmitEjecuta = 'seccionSolicitudAlmacen';
const EmitModalSalidas = 'seccionSalidas';
const EmitModalSalidasExtra = 'seccionSalidasExtra';
const EmitModalEntradas = 'seccionEntradas';

export default {
    name: 'ListaSolicitudAlmacen',
    props: ['sFiltros','pOrigen'],
    components: {
        FormAutorizarSalida,FormEntrada,FormAutorizarSalidaExtra
    },
    data() {
        return {
            ConfigList:{
                Title: 'Solicitudes',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
                GoRoute: 'RouterDelForm',
                BtnNewShow:false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,

            ConfigModalAutorizarSalida:{
                ModalTitle: "Lista de Salidas",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitModalSalidas,
				// ModalSize:'xl',
                FullScreen: true,
                Obj:{}
            },
            ConfigModalAutorizarSalidaExtra:{
                ModalTitle: "Lista de Salidas",
                ModalNameId: 'ModalForm4',
                EmitSeccion: EmitModalSalidasExtra,
				// ModalSize:'xl',
                FullScreen: true,
                Obj:{}
            },
            ConfigModalEntrada:{
                ModalTitle: "Lista de Entradas",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitModalEntradas,
				// ModalSize:'xl',
                FullScreen: true,
                Obj:{}
            },
            oBtnSaveAutorizarSalida:{
                Toast: 0,
                DisableBtn: false,
                EmitSeccion: EmitModalSalidas,
            },
            oBtnSaveAutorizarSalidaExtra:{
                Toast: 0,
                DisableBtn: false,
                EmitSeccion: EmitModalSalidasExtra,
            },
            oBtnSaveEntrada:{
                Toast: 0,
                DisableBtn: false,
                EmitSeccion: EmitModalEntradas,
            },
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("cotzConfirmadasAlmacen",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                // this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('solicitudessalidas/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        IrASolicitud(item){
            this.$router.push({name:'solicitudalmacenForm', params:{Id:item.IdSolicitudAlmacen,IdCotizacion:item.IdCotizacion,FechaEvento:item.FechaEvento,pObjCotizacion:item}});
        },
        VerificarSalida(item,camino){
            if (camino=='extra') {
                this.bus.$emit('NewModal_'+this.ConfigModalAutorizarSalidaExtra.EmitSeccion,item.IdCotizacion,item);
            }
            else{
                this.bus.$emit('NewModal_'+this.ConfigModalAutorizarSalida.EmitSeccion,item.IdCotizacion,item);
            }
        },
        IrASolicitudExtraoficial(item){
            this.$router.push({name:'solicitudsalidaextraForm', params:{IdSolicitudAlmacen:item.IdSolicitudAlmacen,IdCotizacion:item.IdCotizacion,FechaEvento:item.FechaEvento,pObjCotizacion:item}});
        },
        VerPdf(){

        },
        RealizarEntradas(item){
            this.bus.$emit('NewModal_'+this.ConfigModalEntrada.EmitSeccion,item.IdCotizacion,item);
        }
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
